var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import { classToPlain } from 'class-transformer';
import { AppError } from '../../error';
import { Crypto } from '../crypto';
export const getCertificates = createAsyncThunk('events/getCertificates', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ cryptoType }, { rejectWithValue, getState, extra: { inject } }) {
    try {
        const { items, cryptoType: type } = getState().crypto;
        if (!!type && !!cryptoType && type === cryptoType) {
            return items;
        }
        const certificates = yield inject(Crypto).getSerializedCertificates(cryptoType);
        return certificates;
    }
    catch (err) {
        const appError = new AppError('client', {
            code: 500,
            message: 'Ошибка при извлечении сертификатов',
        });
        /* istanbul ignore next */
        if (err instanceof Error && err.message) {
            appError.title = err.message;
        }
        return rejectWithValue(classToPlain(appError));
    }
}));
export const cryptoReducers = (builder) => {
    builder.addCase(getCertificates.pending, (state) => {
        state.hasCertificates = state.status === 'complete' && !!state.items.length;
        state.status = 'loading';
        state.error = null;
    });
    builder.addCase(getCertificates.fulfilled, (state, { payload, meta }) => {
        state.status = 'complete';
        state.error = null;
        state.hasCertificates = !!payload.length;
        state.items = payload;
        state.cryptoType = meta.arg.cryptoType;
    });
    builder.addCase(getCertificates.rejected, (state, { payload }) => {
        state.status = 'failed';
        state.items = [];
        state.hasCertificates = false;
        /* istanbul ignore next */
        state.error = payload
            ? payload.title
            : 'Ошибка при извлечении сертификатов';
    });
};
